<div class="row">
  <div class="col-sm-6 mb-5">
    <p class="text-center mb-4">
      {{ g2Meta.product.star_rating }} {{ 'productReview.outOf5Stars' | cxTranslate }}
      {{ 'common.braceOpen' | cxTranslate }}{{ g2Meta.record_count }} {{ 'productReview.reviews' | cxTranslate
      }}{{ 'common.braceClose' | cxTranslate }}
    </p>
    @for (score of npsScore.collection; track score) {
      <div class="d-flex flex-row mb-3">
        <div class="me-3">
          {{ score.text }}
        </div>
        <div class="flex-fill me-3">
          <div class="progress" style="height:1.875rem">
            <div class="progress-bar bg-sap-blue" [style.width.%]="calcScorePercentage(score)"></div>
          </div>
        </div>
        <p class="percentage">{{ calcScorePercentage(score) }}%</p>
      </div>
    }
  </div>
  <div class="col-sm-6">
    <dcp-first-review [btnText]="ctaText" [g2Product]="g2Meta.product" [infoText]="infoText"></dcp-first-review>
  </div>
</div>
